// node modules
import { combineReducers } from "redux";
// reducers
import cadastro from "./cadastro";
import login from "./login";
import modal from "./modal";
import promo from "./promo";
import user from "./user";
import promos from "./getPromo";
import notify from "./notificacoes";
import cidades from "./cidade";
import categoria from "./categoria";
import getUserPosition from "./getUserPosition";
export default combineReducers({
  cadastro,
  login,
  modal,
  promo,
  user,
  promos,
  notify,
  cidades,
  categoria,
  getUserPosition
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js